import { ErrorBoundary } from 'react-error-boundary';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Suspense } from 'react';
import { CampaignCardError, ErrorComponent } from './CampaignCardError';
import { CampaignCardProps } from './campaign-card-props';
import { CampaignCardSkeleton } from './CampaignCardSkeleton';
import { InnerCampaignCard } from './InnerCampaignCard';

// Avoid refreshing campaign
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: Infinity, retry: 2 },
  },
});

export function CampaignCard(props: CampaignCardProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary
        fallbackRender={({ error, resetErrorBoundary }) => {
          const translations = error instanceof CampaignCardError ? error.translations : undefined;
          const retry = () => {
            queryClient.refetchQueries({
              queryKey: ['channel', props.channelUuid || props.channelInfo?.uuid],
            });
            resetErrorBoundary();
          };
          return (
            <ErrorComponent
              className={props.className}
              title={translations?.['errorTitle']}
              description={translations?.['errorDescription']}
              buttonLabel={translations?.['reload']}
              onRetry={retry}
            />
          );
        }}
      >
        <Suspense fallback={<CampaignCardSkeleton props={props} />}>
          <InnerCampaignCard {...props} />
        </Suspense>
      </ErrorBoundary>
    </QueryClientProvider>
  );
}
